import NestedRouteComponent from 'router/nestedViews/NestedRouteComponent';
import wrapLegacyRoute from 'router/legacy/wrapLegacyRoute';
import translation from 'translation';

const roreMediaplansRoutes = [
  {
    path: 'mediaplans',
    meta: {
      routeName: {
        segmentName: () => translation.tr('Mediaplans')
      },
      permissions: ['READ_RORE_MEDIAPLANS']
    },
    component: NestedRouteComponent,
    children: [
      {
        path: '',
        name: 'roreMediaplansList',
        component: wrapLegacyRoute('roreMediaplansController', 'list')
      },
      {
        path: 'create',
        name: 'roreMediaplanCreate',
        component: wrapLegacyRoute('roreMediaplansController', 'create')
      },
      {
        path: ':mediaplanId(\\d+)',
        name: 'roreMediaplanDetails',
        component: wrapLegacyRoute('roreMediaplansController', 'details')
      },
      {
        path: ':mediaplanId(\\d+)/orders',
        name: 'roreMediaplanOrders',
        component: wrapLegacyRoute('roreMediaplansController', 'orders')
      },
      {
        path: ':mediaplanId(\\d+)/snapshots',
        name: 'roreMediaplanSnapshots',
        component: wrapLegacyRoute('roreMediaplansController', 'snapshots')
      },
      {
        path: 'booking/view',
        name: 'roreMediaplansBookingView',
        component: wrapLegacyRoute('roreMediaplansController', 'bookingView')
      }
    ]
  }
];

export default roreMediaplansRoutes;
